/**
 * 设置延时
 * @param {number} delay 延时时间, 单位ms, 默认1000ms
 * @returns
 */
async function sleep(delay) {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve();
    }, delay || 1000);
  });
}

export default sleep;
